import { createReducer } from "../../../_common/common";
import { SET_CERTIFICATE_TYPES, SET_PURCHASED_CERTIFICATES } from "../actions/constants";

const initialState = {
    types: null, // Para almacenar los tipos de certificados
}
export const certificates = createReducer(initialState, {
    [SET_CERTIFICATE_TYPES]: (state, payload) => ({
        ...state,
        types: payload
    }),
    [SET_PURCHASED_CERTIFICATES]: (state, payload) => ({
        ...state,
        purchasedCertificates: {
            ...state.purchasedCertificates,
            ...payload
        }
    })
});
